import api from '@/api/index'
import config from '@/config/index'
import {GETUSERS_SUCCESS, GETROLES_SUCCESS} from "../types";

const state = {
  users: [], // 所有用户
  roles: [] //  所有角色
}

const actions = {
  getUsers (store, params) { // 获取所有用户
    var that = this
    return new Promise(function (resolve, reject) {
      api.post(config.bylApiPath, '/entUser/search', params, function (r) { // 正常
        resolve(r)
        if (r.data) {
          store.commit(GETUSERS_SUCCESS, r.data) // 更新state
        }
      })
    })
  },
  getRoles (store) { // 获取所有角色
    api.post(config.bylBaseCenterPath, '/role/roles', null, function (r) { // 正常
      if (r.data) {
        store.commit(GETROLES_SUCCESS, r.data)
      }
    })
  }
}
const mutations = {
  [GETUSERS_SUCCESS] (state, action) {
    state.users = action
  },
  [GETROLES_SUCCESS] (state, action) {
    state.roles = action
  }
}

const getters = {
  getCurrentUsers: state => {
    if (state.users) {
      return state.users
    } else {
      return []
    }
  },
  getCurrentRoles: state => {
    if (state.roles) {
      return state.roles
    } else {
      return []
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js